// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"8":"packages","345":"portfolio","353":"contact","543":"gallery","594":"about","609":"faq"}[chunkId] + "." + {"8":"45a92f46","345":"69e51d16","353":"50092d06","543":"ad802fc2","594":"a293cc84","609":"e2675887"}[chunkId] + ".css";
};